export default {
  bankName: "",
  BIK: "",
  receiverINN: "",
  account: "",
  KPP: "",
  correspondentAcc: "",
};
